const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card',
};

document.addEventListener("DOMContentLoaded", function(event) {
  initButtons();
  initGrid();  
});

window.addEventListener('load', (event) => {
  initButtons();
  
  setTimeout(() => {
    initButtons();  
  }, "2000");
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  document.querySelector('.wishlist-link__count').innerText = event.detail.wishlist.length;
  if(document.querySelector('.wishlist-link__count').innerText==0)
  {
    document.querySelector('.wishlist-link__count').style.display='none';
  }
  else
  {
    document.querySelector('.wishlist-link__count').style.display='inline';
  }

  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
  document.querySelector('.wishlist-link__count').innerText = event.detail.wishlist.length;
  if(document.querySelector('.wishlist-link__count').innerText==0)
  {
    document.querySelector('.wishlist-link__count').style.display='none';
  }
  else
  {
    document.querySelector('.wishlist-link__count').style.display='inline';
  }
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
  document.querySelector('.wishlist-link__count').innerText = event.detail.wishlist.length;
  if(document.querySelector('.wishlist-link__count').innerText==0)
  {
    document.querySelector('.wishlist-link__count').style.display='none';
  }
  else
  {
    document.querySelector('.wishlist-link__count').style.display='inline';
  }
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/collections/wishlist-info`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');

    var productCard = htmlDocument.documentElement.querySelectorAll('.ProductItem');

    for(i=0;i<productCard.length;i++)
    {
      if(productCard[i].querySelector('button').dataset.productHandle==handle)
      {
        productCard=productCard[i];
      }
    }

    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};
/*
const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');

    var productCard = htmlDocument.documentElement.querySelector('.product-detail');

   // productCard.querySelector('.image-cont--with-secondary-image').classList.remove('image-cont--with-secondary-image');
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};
*/
const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
  
  if(event.detail.wishlist.length==0)
  {
    document.querySelector('.wishlist-empty').style.display='block';
  }
  else
  {
    document.querySelector('.wishlist-empty').style.display='none';
  }
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
      
    if (button.classList.contains('buttonInitialized') == false)    //only initialize each button once, important for delayed sections like on prod.recomm.
    { 
      button.addEventListener('click', () => {
        event.preventDefault();
        updateWishlist(productHandle);
        //button.classList.toggle(BUTTON_ACTIVE_CLASS);
      
      for(i=0;i<document.querySelectorAll(`[data-product-handle="${productHandle}"]`).length;i++)
      {
      	document.querySelectorAll(`[data-product-handle="${productHandle}"]`)[i].classList.toggle(BUTTON_ACTIVE_CLASS);
      }
      
      });
      button.classList.add('buttonInitialized');
    }
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });

  document.dispatchEvent(event);

  if (buttons.length) setupButtons(buttons);
  else return;
  
  console.log(buttons);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

